module.exports = __webpack_public_path__ + "img/V-L-5-unload-connect.f7295e0a.png";